import { render, staticRenderFns } from "./CovCheckResultModal.vue?vue&type=template&id=2a634d89&scoped=true&"
import script from "./CovCheckResultModal.vue?vue&type=script&lang=js&"
export * from "./CovCheckResultModal.vue?vue&type=script&lang=js&"
import style0 from "./CovCheckResultModal.vue?vue&type=style&index=0&id=2a634d89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a634d89",
  null
  
)

export default component.exports